import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, CircularProgress, Stack, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { Pie, Bar } from 'react-chartjs-2';
import adminStatsApi from '../../api/adminStatsApi';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

export default function DashboardAdminMobile() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear());
  const years = [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2];

  useEffect(() => {
    setLoading(true);
    adminStatsApi.getDashboardStats(year)
      .then(res => setStats(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [year]);

  if (loading) return <CircularProgress />;
  if (!stats) return <div>Nessun dato</div>;

  // ========================= KPI =========================
  let pagati=0, verificati=0, inAttesa=0;
  stats.andamentoMensile.forEach(r => {
    if(r.statoPagamento==='PAGATO') pagati += r.totale;
    if(r.statoPagamento==='VERIFICATO') verificati += r.totale;
    if(r.statoPagamento==='IN_ATTESA') inAttesa += r.totale;
  });

  // ========================= Andamento mensile =========================
  const monthlyMap = {};
  stats.andamentoMensile.forEach(r => {
    const key = `${r.year}-${r.month}`;
    if (!monthlyMap[key]) monthlyMap[key] = { PAGATO: 0, VERIFICATO: 0, IN_ATTESA: 0, FALLITO: 0 };
    monthlyMap[key][r.statoPagamento] = r.totale;
  });
  const months = Object.keys(monthlyMap);
  const andamentoChart = {
    labels: months,
    datasets: [
      { label: 'Pagato', data: months.map(m => monthlyMap[m].PAGATO), backgroundColor: '#4caf50' },
      { label: 'Verificato', data: months.map(m => monthlyMap[m].VERIFICATO), backgroundColor: '#2196f3' },
      { label: 'In attesa', data: months.map(m => monthlyMap[m].IN_ATTESA), backgroundColor: '#ff9800' },
      { label: 'Fallito', data: months.map(m => monthlyMap[m].FALLITO), backgroundColor: '#f44336' }
    ]
  };

  // ========================= Pie Charts =========================
  const contrattiPie = {
    labels: stats.distribuzioneContratti.map(c => c.tipoContratto),
    datasets: [{
      data: stats.distribuzioneContratti.map(c => c.numeroContratti),
      backgroundColor: ['#0088FE','#00C49F','#FFBB28','#FF8042']
    }]
  };
  const fatturatoPie = {
    labels: stats.distribuzioneFatturato.map(f => f.tipoContratto),
    datasets: [{
      data: stats.distribuzioneFatturato.map(f => f.fatturato),
      backgroundColor: ['#4caf50','#2196f3','#ff9800','#9c27b0']
    }]
  };

  return (
    <Box sx={{ p:2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Dashboard Admin {year}</Typography>

      {/* Selezione anno */}
      <FormControl sx={{ mb: 2, width: '100%' }}>
        <InputLabel>Anno</InputLabel>
        <Select value={year} label="Anno emissione pagamento" onChange={e => setYear(e.target.value)}>
          {years.map(y => <MenuItem key={y} value={y}>{y}</MenuItem>)}
        </Select>
      </FormControl>

      {/* KPI */}
      <Stack spacing={1} sx={{ mb:2 }}>
        <Card sx={{ bgcolor:'#4caf50', color:'#fff' }}>
          <CardContent>
            <Typography>Fatturato Pagati</Typography>
            <Typography>{pagati} €</Typography>
          </CardContent>
        </Card>
        <Card sx={{ bgcolor:'#2196f3', color:'#fff' }}>
          <CardContent>
            <Typography>Fatturato Verificati</Typography>
            <Typography>{verificati} €</Typography>
          </CardContent>
        </Card>
        <Card sx={{ bgcolor:'#ff9800', color:'#fff' }}>
          <CardContent>
            <Typography>Fatturato In Attesa</Typography>
            <Typography>{inAttesa} €</Typography>
          </CardContent>
        </Card>
      </Stack>

      {/* Pie Charts */}
      <Stack spacing={2} sx={{ mb: 2 }}>
        <Card><CardContent><Typography>Contratti per tipologia</Typography><Pie data={contrattiPie} /></CardContent></Card>
        <Card><CardContent><Typography>Fatturato per tipologia</Typography><Pie data={fatturatoPie} /></CardContent></Card>
      </Stack>

      {/* Andamento mensile bar scrollabile */}
      <Card>
        <CardContent>
          <Typography sx={{ mb:1 }}>Andamento mensile importi</Typography>
          <Box sx={{ overflowX: 'auto' }}>
            <Box sx={{ width: Math.max(months.length * 80, '100%') }}>
              <Bar data={andamentoChart} options={{ responsive: true, maintainAspectRatio: false }} height={250} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
